import React from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';

const InterfaceSelect = ({ value, options, onChange }) => {
  const inputBg = useColorModeValue('white', 'navy.600');
  const textColor = useColorModeValue('navy.700', 'white');
  const hoverBg = useColorModeValue('gray.200', 'navy.500');
  const focusBorderColor = useColorModeValue('navy.500', 'navy.300');

  const [selected, setSelected] = React.useState(value ?? null);

  // Optional: update selected if value prop changes
  React.useEffect(() => {
    setSelected(value);
  }, [value]);

  function getLabelByValue(options, selectedValue) {
    if (Array.isArray(options)) {
      // Array of {label, value}
      const found = options.find(
        (opt) =>
          (typeof opt === 'object' && opt.value === selectedValue) ||
          opt === selectedValue,
      );
      if (typeof found === 'object' && found !== null) {
        return found.label;
      }
      if (typeof found === 'string') {
        return found;
      }
      return 'Select';
    } else {
      // Object: {label: value}
      const entry = Object.entries(options).find(
        ([label, val]) => val === selectedValue,
      );
      return entry ? entry[0] : 'Select Value';
    }
  }

  const handleSelect = (val) => {
    setSelected(val);
    if (onChange) onChange(val);
  };

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        bg={inputBg}
        color={textColor}
        borderRadius="lg"
        border="2px"
        overflowY="auto"
        borderColor={useColorModeValue('gray.300', 'navy.600')}
        _hover={{ bg: hoverBg }}
        _focus={{
          outline: 'none',
          borderColor: focusBorderColor,
          boxShadow: `0 0 0 1px ${focusBorderColor}`,
        }}
        size="sm"
        width="100%"
        textAlign="left"
      >
        {getLabelByValue(options, selected)}
      </MenuButton>
      <MenuList
        borderRadius="lg"
        fontSize="14px"
        zIndex="1000"
        p="2"
        bg={inputBg}
        color={textColor}
        boxShadow={
          'rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px;'
        }
      >
        {Array.isArray(options)
          ? options.map((opt, idx) =>
              typeof opt === 'object' && opt !== null ? (
                <MenuItem
                  key={opt.value ?? idx}
                  onClick={() => handleSelect(opt.value)}
                  _hover={{ bg: hoverBg }}
                  bg={inputBg}
                  fontWeight={500}
                  my={2}
                >
                  {opt.label}
                </MenuItem>
              ) : (
                <MenuItem
                  key={opt}
                  onClick={() => handleSelect(opt)}
                  _hover={{ bg: hoverBg }}
                  bg={inputBg}
                  fontWeight={500}
                  my={2}
                >
                  {opt}
                </MenuItem>
              ),
            )
          : Object.entries(options).map(([label, value]) => (
              <MenuItem
                key={value}
                bg={inputBg}
                onClick={() => handleSelect(value)}
                _hover={{ bg: hoverBg }}
                fontWeight={500}
                my={2}
              >
                {label}
              </MenuItem>
            ))}
      </MenuList>
    </Menu>
  );
};

export default InterfaceSelect;
